import { FC } from 'react';
import { Box, AnimatedShape } from '@altermaind/web/ui';

export const StickyTableSkeleton: FC = () => {
  const generateRandomInt = (min: number, max: number) =>
    Math.floor(Math.random() * (max - min + 1)) + min;
  const numberOfColumn = 3;
  const minRows = 3;
  const maxRows = 4;
  const randomRows = generateRandomInt(minRows, maxRows);
  const columns = new Array(numberOfColumn).fill(null);
  const rows = new Array(randomRows).fill(null);
  const minFirstColumnWidthPercentage = 40;
  const maxFirstColumnWidthPercentage = 55;

  return (
    <Box>
      {/* TABLE HEADER */}
      <Box display='flex' flexDirection='row' justifyContent='space-between' mt='s' mb='xs'>
        <AnimatedShape height={11} width='30%' mr='xxxs' variant='semiRound' />
        <Box
          width='45%'
          display='flex'
          flexDirection='row'
          justifyContent='flex-end'
          style={{ columnGap: 10 }}
        >
          {columns.map(() => (
            <AnimatedShape key={Math.random()} height={11} variant='semiRound' />
          ))}
        </Box>
      </Box>
      {/* TABLE ROWS */}
      {rows.map(() => (
        <Box
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
          mt='xxs'
          key={Math.random()}
        >
          <AnimatedShape
            height={20}
            width={`${generateRandomInt(minFirstColumnWidthPercentage, maxFirstColumnWidthPercentage)}%`}
            mr='xxxs'
            variant='semiRound'
          />
          <Box
            width='45%'
            display='flex'
            flexDirection='row'
            justifyContent='flex-end'
            style={{ columnGap: 10 }}
          >
            {columns.map(() => (
              <Box justifyContent='center' display='flex' flex={1} key={Math.random()}>
                <AnimatedShape width={25} height={20} variant='semiRound' />
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
